import { retrieveFromStorage } from "../../Components/Functions";
import { UPDATE, UPDATE_TO_LOCALSTORAGE_RIDER, UPDATERIDER, USER_AUTHENTICATION_DATA } from "./types";



const INITIAL_STATE = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};


// const INITIAL_STATE = {
// 	auth: auth,
// 	access: access,
// 	refresh: refresh,
// 	data: null,
// 	user: user,
// };


export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action,
			};

		default:
			return state;
	}
};

const local_state = retrieveFromStorage(UPDATE_TO_LOCALSTORAGE_RIDER);
export const _NEW_RIDER = {
	name: "",
	email: "",
	phone: "",
	password: "",
	image: null,
	base_salary: 0,
	percent_on_delivery: 0,
	documents: [],
}
const RIDER_FORM_INITIAL_STATE = {
	..._NEW_RIDER,
	...local_state
}

export const riderFormReducer = (state = RIDER_FORM_INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATERIDER:
			return {
				...state,
				...action,
			};

		default:
			return state;
	}
};
